/**
 * WssActions Component
 * Action buttons for WSS check-in feature
 */

import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { RiDirectionFill } from "react-icons/ri";
import styles from "@components/MarketWorking/MyTeam/MyDealer.module.css";

const WssActions = ({
  customerCode,
  onNavigateClick,
  onCheckInClick,
  onPreviousObservationsClick,
  onMyDiaryClick,
  onMySRClick,
}) => {
  return (
    <>
      {/* Row 1: Navigate, Check In, Previous Observations */}
      <div className="row m-0 p-2">
        <div className="col-4 ps-0">
          <Link to="#">
            <Button
              className={styles.myDealer__navButton}
              onClick={onNavigateClick}
            >
              Navigate
              <RiDirectionFill
                style={{ marginLeft: "4px", marginBottom: "1px" }}
              />
            </Button>
          </Link>
        </div>
        
        <div className="col-4">
          <Button 
            className={styles.myDealer__navButton} 
            onClick={onCheckInClick}
          >
            Check In
          </Button>
        </div>
        
        <div className="col-4 pe-0">
          <Link to="#">
            <Button
              className={styles.myDealer__navButton}
              onClick={onPreviousObservationsClick}
            >
              Previous Observations
            </Button>
          </Link>
        </div>
      </div>

      {/* Row 2: My Diary, My SR */}
      <div className="row m-0 p-2 flex justify-content-center align-items-center">
        <div className="col-4 ps-0">
          <Link to="#">
            <Button
              className={styles.myDealer__navButton}
              onClick={onMyDiaryClick}
            >
              My Diary
            </Button>
          </Link>
        </div>

        <div className="col-4">
          <Link to="#">
            <Button
              className={styles.myDealer__navButton}
              onClick={onMySRClick}
            >
              My SR
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default WssActions;
